import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-container">
      <h1>About Me</h1>
      <h3>Inspiration:</h3>
      <p>
        When my wife and I go camping or hiking, I am often captivated by the beautiful
        sunrises and sunsets that sink into the horizon. Whether at a destination or along
        the way, I never tire of seeing these simple yet beautiful views.
      </p>

      <h3>Process:</h3>
      <p> 
        I photograph these landscapes and combine the images with my memories. It
        takes several weeks to complete a piece, layering different shades of oil paint on
        each canvas.
      </p>
    

      <h3>Motivation:</h3>
      <p>
        By continuing to paint landscapes that combine photo images and imagination, I
        learn things about myself and my creativity that I had never realized before, and I
        sometimes want to share my appreciation for the beauty of nature with others
        through my work. It brings me great joy to feel that I can communicate with family,
        friends, and even people I meet for the first time through the finished landscapes.
      </p>
    </div>
  );
}

export default About;